module.exports = __webpack_public_path__ + "static/media/bkg_3.b96277ed.jpg";